import React from 'react';
import ReactDOM from 'react-dom/client';
// Selbst gehostete Fonts (statt Google-Fonts-CDN, DSGVO): gebündelt via @fontsource,
// gleiche Gewichte wie zuvor im <link> in index.html.
import '@fontsource/archivo/600.css';
import '@fontsource/archivo/700.css';
import '@fontsource/archivo/800.css';
import '@fontsource/archivo/900.css';
import '@fontsource/hanken-grotesk/400.css';
import '@fontsource/hanken-grotesk/500.css';
import '@fontsource/hanken-grotesk/600.css';
import '@fontsource/hanken-grotesk/700.css';
import '@fontsource/space-mono/400.css';
import '@fontsource/space-mono/700.css';
import './App.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

// Umami Analytics — fest auf die selbst gehostete Instanz verdrahtet (umami.gsk-it.de,
// läuft auf dem Hetzner-Infra-Server), kein Env-Var nötig. Das Branch-Deployment
// radevents.gsk-it.de trackt in einen eigenen (temporären) Website-Eintrag, damit
// Event-Tests die Produktions-Zahlen nicht verfälschen; localhost trackt gar nicht
// (data-domains). Beim Release: Domain des Prod-Eintrags in Umami auf
// radsport-events.de anpassen — die Website-ID und damit die Historie bleiben.
const umamiUrl = 'https://umami.gsk-it.de';
const umamiIsStaging = window.location.hostname.endsWith('.gsk-it.de');
{
  const script = document.createElement('script');
  script.defer = true;
  script.src = `${umamiUrl}/script.js`;
  script.dataset.websiteId = umamiIsStaging
    ? '2351aed3-3593-4faf-bc32-ffa5b4604450'
    : '230f7954-7017-4ab3-8903-86d9eac39c69';
  script.dataset.domains = umamiIsStaging
    ? 'radevents.gsk-it.de'
    : 'radsport-events.de,shop.radsport-events.de,rad-events.net';
  document.head.appendChild(script);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// Actively unregister any service worker (the old SW had a no-op fetch handler
// that disabled iOS bfcache, causing flicker on swipe-back). The SW provided
// no real benefit, so we remove it entirely.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then(regs => regs.forEach(r => r.unregister()))
    .catch(() => {});
}
